export enum MarketingAttributionModelType {
  FIRST_TOUCH = 'FIRST_TOUCH',
  LAST_TOUCH = 'LAST_TOUCH',
  MULTI_TOUCH = 'MULTI_TOUCH',
  EVEN_DISTRIBUTION = 'EVEN_DISTRIBUTION',
}
